export const TASK_STATUSES = [
  { id: "backlog", label: "Beklemede", color: "#64748b", chip: "bg-slate-100 text-slate-700 border-slate-200" },
  { id: "planned", label: "Planlandı", color: "#0ea5e9", chip: "bg-sky-100 text-sky-700 border-sky-200" },
  { id: "in_progress", label: "Devam Ediyor", color: "#4f46e5", chip: "bg-indigo-100 text-indigo-700 border-indigo-200" },
  { id: "waiting", label: "Bekliyor", color: "#f59e0b", chip: "bg-amber-100 text-amber-700 border-amber-200" },
  { id: "review", label: "İncelemede", color: "#8b5cf6", chip: "bg-violet-100 text-violet-700 border-violet-200" },
  { id: "completed", label: "Tamamlandı", color: "#10b981", chip: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  { id: "cancelled", label: "İptal", color: "#ef4444", chip: "bg-rose-100 text-rose-700 border-rose-200" },
];

export const PRIORITIES = [
  { id: "low", label: "Düşük", color: "#64748b", chip: "bg-slate-100 text-slate-700" },
  { id: "medium", label: "Orta", color: "#0ea5e9", chip: "bg-sky-100 text-sky-700" },
  { id: "high", label: "Yüksek", color: "#f59e0b", chip: "bg-amber-100 text-amber-700" },
  { id: "urgent", label: "Acil", color: "#ef4444", chip: "bg-rose-100 text-rose-700" },
];

export const PROJECT_STATUSES = [
  { id: "planning", label: "Planlama", chip: "bg-sky-100 text-sky-700" },
  { id: "active", label: "Aktif", chip: "bg-emerald-100 text-emerald-700" },
  { id: "on_hold", label: "Beklemede", chip: "bg-amber-100 text-amber-700" },
  { id: "completed", label: "Tamamlandı", chip: "bg-indigo-100 text-indigo-700" },
  { id: "archived", label: "Arşivlendi", chip: "bg-slate-100 text-slate-700" },
];

export const DEAL_STAGES = [
  { id: "new_lead", label: "Yeni Aday", color: "#64748b" },
  { id: "contacted", label: "İletişim Kuruldu", color: "#0ea5e9" },
  { id: "qualified", label: "Nitelikli", color: "#6366f1" },
  { id: "proposal", label: "Teklif Gönderildi", color: "#8b5cf6" },
  { id: "negotiation", label: "Görüşme", color: "#f59e0b" },
  { id: "won", label: "Kazanıldı", color: "#10b981" },
  { id: "lost", label: "Kaybedildi", color: "#ef4444" },
];

export const TICKET_STATUSES = [
  { id: "new", label: "Yeni", chip: "bg-sky-100 text-sky-700" },
  { id: "open", label: "Açık", chip: "bg-indigo-100 text-indigo-700" },
  { id: "in_progress", label: "Devam Ediyor", chip: "bg-violet-100 text-violet-700" },
  { id: "waiting_customer", label: "Müşteri Bekleniyor", chip: "bg-amber-100 text-amber-700" },
  { id: "resolved", label: "Çözüldü", chip: "bg-emerald-100 text-emerald-700" },
  { id: "closed", label: "Kapalı", chip: "bg-slate-100 text-slate-700" },
];

export const REQUEST_TYPES = [
  { id: "purchase", label: "Satın Alma Talebi" },
  { id: "expense", label: "Masraf Talebi" },
  { id: "marketing", label: "Pazarlama Talebi" },
  { id: "it", label: "IT Destek Talebi" },
  { id: "maintenance", label: "Bakım Talebi" },
  { id: "personnel", label: "Personel Talebi" },
  { id: "customer", label: "Müşteri Talebi" },
  { id: "stock", label: "Ürün / Stok Talebi" },
  { id: "general", label: "Genel Yönetim Talebi" },
];

export const LEAVE_TYPES = [
  { id: "annual", label: "Yıllık İzin" },
  { id: "sick", label: "Hastalık İzni" },
  { id: "unpaid", label: "Ücretsiz İzin" },
  { id: "excuse", label: "Mazeret İzni" },
];

export const label = (list, id) => list.find((x) => x.id === id)?.label || id;
export const item = (list, id) => list.find((x) => x.id === id) || {};
